// @flow

import React from 'react';
import type { QuartilsValue, GoodwillRatioType } from '../../../../../types/apolloType';
import { autoQuantityCurrencyString } from '../../../../../utils/formatUtils';

type Props = {
  impactedStores: GoodwillRatioType[],
  quartils: QuartilsValue,
}

export default function GoodwillQuantilsLegend(props: Props) {
  const getImpactValues = (impactedStores: GoodwillRatioType[]): number[] => (
    impactedStores.length !== 0
      ? impactedStores.map(impactedStore => impactedStore.impactValue)
      : [0]
  );

  const formatQuantil = (quantil: number | string) => autoQuantityCurrencyString(quantil, 0);

  return (
    <div>
      <div className="heatmap-indicator-quartiles">
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(Math.min(...getImpactValues(props.impactedStores)).toString())}
          </div>
          <div className="down-arrow" />
        </div>
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(props.quartils.q1)}
          </div>
          <div className="down-arrow" />
        </div>
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(props.quartils.q2)}
          </div>
          <div className="down-arrow" />
        </div>
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(props.quartils.q3)}
          </div>
          <div className="down-arrow" />
        </div>
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(props.quartils.q4)}
          </div>
          <div className="down-arrow" />
        </div>
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(props.quartils.q5)}
          </div>
          <div className="down-arrow" />
        </div>
        <div className="quartil-tooltip">
          <div className="quartil-text">
            {formatQuantil(Math.max(...getImpactValues(props.impactedStores)).toString())}
          </div>
          <div className="down-arrow" />
        </div>
      </div>
      <div className="heatmap-indicator-container">
        <div />
        <div className="heatmap-indicator">
          <div className="veryVeryHigh" />
          <div className="veryHigh" />
          <div className="high" />
          <div className="low" />
          <div className="veryLow" />
          <div className="veryVeryLow" />
        </div>
        <div />
      </div>
    </div>
  );
}
